import logo_neuratio_dark from "assets/images/logos/logo_neuratio_dark_blue.png";

export default function Loading() {
    return <div className="loading-div"><img className="loading-logo" src={logo_neuratio_dark} alt=""></img></div>;
}